<template>
  <div>
    <h2>{{ application.name }}</h2>
  </div>
</template>
<script>
import Api from '@/store/jsonapi';

export default {
  data: function () {
    return {
      application: {}
    };
  },
  methods: {},
  async mounted() {
    let { data: application } = Api.findAll('oauth_application', this.application_id);

    this.application = application;
  },
  props: ['application_id']
};
</script>

<style scoped></style>
